import { render, staticRenderFns } from "./SpecialHome.vue?vue&type=template&id=1f1cdaf9&scoped=true&"
import script from "./SpecialHome.vue?vue&type=script&lang=js&"
export * from "./SpecialHome.vue?vue&type=script&lang=js&"
import style0 from "./SpecialHome.vue?vue&type=style&index=0&id=1f1cdaf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1cdaf9",
  null
  
)

export default component.exports